<template>
  <div class="game-form">
    <div class="game-form-header">
      <drawer-dialog-controls
        @close="$emit('close')"
        @save="$emit('save', localModelValue)"
      >
        {{ dialogTitle }}
      </drawer-dialog-controls>
    </div>

    <div class="game-form-content">
      <v-card>
        <v-card-title>
          Game settings
        </v-card-title>
        <v-divider />

        <v-container>
          <v-row class="mx-0">
            <v-col cols="6" class="pb-0">
              <v-row class="mx-0">
                <v-text-field
                  v-model="localModelValue.name"
                  label="Name"
                  placeholder="Name"
                />
              </v-row>
            </v-col>
            <v-col cols="6" class="pb-0">
              <v-text-field
                  v-model="localModelValue.external_id"
                  label="External Id"
                  placeholder="External Id"
                />
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-text-field
                  v-model="localModelValue.code"
                  label="Code"
                  placeholder="Code"
                />
              </v-row>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-text-field
                  v-model="localModelValue.code_external"
                  label="Code external"
                  placeholder="Code external"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-text-field
                  v-model="localModelValue.code_mobile"
                  label="Code mobile"
                  placeholder="Code mobile"
                />
              </v-row>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-text-field
                  v-model="localModelValue.code_mobile_external"
                  label="Code mobile external"
                  placeholder="Code mobile external"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-text-field
                  v-model="localModelValue.data.rollover_allowed"
                  label="Rollover allowed"
                  type="number"
                  min="0"
                />
              </v-row>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-select
                  v-model="localModelValue.type"
                  :items="typeOptions"
                  label="Type"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-select
                  v-model="localModelValue.brand_id"
                  :items="brandOptions"
                  label="Brand"
                />
              </v-row>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-row class="mx-0">
                <v-select
                  v-model="localModelValue.system_id"
                  :items="systemOptions"
                  label="System"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col cols="3" class="pt-0">
              <v-row class="mx-0">
                <v-checkbox
                  v-model="localModelValue.enabled"
                  label="Enabled"
                />
              </v-row>
            </v-col>
            <v-col cols="3" class="pt-0">
              <v-row class="mx-0 justify-center">
                <v-checkbox
                  v-model="localModelValue.allow_freespins"
                  label="Allow freespins"
                />
              </v-row>
            </v-col>
            <v-col cols="3" class="pt-0">
              <v-row class="mx-0 justify-end">
                <v-checkbox
                  v-model="localModelValue.data.bonus_no_play"
                  label="No play bonus"
                />
              </v-row>
            </v-col>
            <v-col cols="3" class="pt-0">
              <v-row class="mx-0 justify-end">
                <v-checkbox
                  v-model="localModelValue.data.loyalty_allowed"
                  label="Loyalty allowed"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col cols="12" class="pt-0">
              <vue-json-editor
                v-model="localModelValue.data"
                mode="code"
                :modes="[]"
                :show-btns="false"
                :expandedOnStart="true"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { DrawerDialogControls } from '@/components/core/DrawerDialog';
import vueJsonEditor from 'vue-json-editor'
export default {
  components: {
    DrawerDialogControls,
    vueJsonEditor
  },

  props: {
    game: {
      type: Object,
      default: () => ({})
    },
    brandOptions: {
      type: Array,
      default: () => ([])
    },
    systemOptions: {
      type: Array,
      default: () => ([])
    },
    typeOptions: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      localModelValue: {}
    }
  },

  created() {
    this.localModelValue = cloneDeep(this.game);
  },

  computed: {
    dialogTitle() {
      return this.game.game_id ? `Edit game ${this.game.game_id}` : 'Add new game';
    }
  }
}
</script>
